import { render, staticRenderFns } from "./PhoneNumberComponent.vue?vue&type=template&id=21573e8d"
import script from "./PhoneNumberComponent.vue?vue&type=script&lang=ts"
export * from "./PhoneNumberComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports